export default __webpack_public_path__ + "static/media/swim.27539172.png";